import Header from './Header'
import UnderConstruction from './UnderConstruction'
import NoAccess from './NoAccess'
import NoMatch from './NoMatch'
import Snackbar from './Snackbar'
import Auth from './Auth'
import Login from './Login'
import Logout from './Logout'
import DownloadButton from './DownloadButton'
import UploadButton from './UploadButton'
import Dropzone from './Dropzone'
import Search from './Search'

export default {
  Header,
  UnderConstruction,
  NoAccess,
  NoMatch,
  Snackbar,
  Auth,
  Login,
  Logout,
  DownloadButton,
  UploadButton,
  Dropzone,
  Search
}



// WEBPACK FOOTER //
// ./src/core/components/index.js